<template>
  <div>
    <div v-if="!show || !show.title">
      <ith-detail-general-skeleton />
    </div>
    <div v-else>
      <div class="conteiner div">
        <h2>
          {{ show.title }} <span> ({{ show.year }}) </span>
        </h2>
        <div class="btn-rrss">
          <div class="btn-rrss--item">
            <button
              @click="setWatchlist()"
              class="btn-rrss--btn"
              :class="{
                active: show.watchlist,
                backgroundActive: show.watchlist,
              }"
            >
              <font-awesome-icon v-if="!show.watchlist" icon="plus-circle" />
              <font-awesome-icon v-else icon="check" />
            </button>
            <span class="btn-rrss--title">Watchlist </span>
          </div>

          <div class="btn-rrss--item">
            <button class="btn-rrss--btn" @click.prevent="makeRating()">
              <font-awesome-icon icon="star" />
            </button>
            <div class="btn-rrss--title">Rate it</div>

            <!-- <button
              @click="setLiked()"
              class="btn-rrss--btn"
              :class="{ active: show.liked, backgroundActive: show.liked }"
            >
              <font-awesome-icon icon="thumbs-up" />
            </button>
            <span class="btn-rrss--title">Like</span> -->
          </div>
          <div class="btn-rrss--item">
            <button
              @click="setWatched()"
              class="btn-rrss--btn"
              :class="{ active: show.watched, backgroundActive: show.watched }"
            >
              <font-awesome-icon icon="eye" />
            </button>
            <span class="btn-rrss--title">Watched </span>
          </div>
        </div>

        <h3>Cast</h3>
        <p class="description">
          {{ show.actors }}
        </p>
        <h3 class="subtitle">Overview</h3>
        <p class="description">
          {{ show.description }}
        </p>
        <h3 v-show="show.platforms.length > 0" class="subtitle">
          Where to watch
        </h3>
        <div class="platforms">
          <div v-for="p in show.platforms" :key="p.platform">
            <a :href="p.url" target="_blank"
              ><div
                class="platform--img"
                :class="{ skeletonLoading: p.platform.length < 100 }"
                v-lazy-container="{ selector: 'img' }"
              >
                <img :data-src="p.platform" alt="platform" /></div
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["show", "user", "platforms_temp", "ratingModal"]),
  data: () => ({
    params: { showId: "", show: "", inWatchlist: "", watched: "", like: "" },
  }),
  created() {
    this.params.showId = this.$route.params.id;
    this.params.show = this.$route.params.id;
  },

  methods: {
    makeRating() {
      this.$store.commit("toggleRatingModal");
    },

    async setLiked() {
      this.params.like = !this.show.liked;
      this.$store.commit("EDIT_LIKED_SHOW", !this.show.liked);
      this.$Parse.Cloud.run("saveShowLike", this.params);
    },
    async setWatched() {
      this.$store.commit("EDIT_WATCHED_SHOW", !this.show.watched);
      this.$store.dispatch("SET_WATCHED", this.show);
    },
    async setWatchlist() {
      this.$store.commit("EDIT_INWATCHLIST_SHOW", !this.show.watchlist);
      this.$store.dispatch("SET_WATCHLIST", this.show);
    },
  },
};
</script>

<style scoped>
button {
  outline: none;
}
.div {
  margin-top: 0px;
  position: relative;
}

h2 > span {
  font-weight: 400;
  font-size: 30px;
}
h2 {
  margin: 5px 0 20px;
  font-size: 30px;
}

h3 {
  margin: 35px 0 0 0;
  font-size: 20px;
}
.subtitle {
  margin: 15px 0 0 0;
}
p {
  line-height: 2;
}

.platforms {
  padding: 20px 10px 15px 0px;
  display: grid;
  grid-template-columns: repeat(8, auto);
  justify-content: start;
  column-gap: 10px;
}
.platforms--item {
  border-radius: 15px;
  cursor: pointer;
  width: 90px;
  height: 60px;
  object-fit: cover;
}
.description {
  font-size: 16px;
  text-align: justify;
  margin-bottom: 5%;
}

.btn-rrss {
  position: absolute;
  right: 0px;
  top: 20px;
  display: grid;
  grid-template-columns: repeat(3, 55px);
  justify-content: end;
  column-gap: 20px;
}
.btn-rrss--item {
  display: grid;
  grid-template-columns: 100%;
  justify-self: center;
  row-gap: 15px;
}
.btn-rrss--btn {
  height: 40px;
  width: 40px;
  margin-top: 20px;
  background-color: #375072;
  color: #939292;
  border: 0px;
  border-radius: 10px;
  padding: 5px;
  font-size: 1.3em;
  justify-self: center;
  cursor: pointer;
}
.backgroundActive {
  background-color: #94c659;
}

.active {
  color: white;
}
.btn-rrss--btn:hover {
  background-color: #2c3d53;
}
.btn-rrss--btn:active {
  background-color: #283441;
}

.btn-rrss--title {
  font-size: 0.75em;
  justify-self: center;
}
.platform--img {
  border-radius: 10px;
  width: 90px;
  height: 60px;
  margin-bottom: 10px;
  background-color: #738092;
}
.platform--img > img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}

.skeletonLoading {
  box-shadow: 0 4px 10px 0 rgba(33, 33, 33, 0.15);
  border-radius: 10px;
  position: relative;
  overflow: hidden;
}
.skeletonLoading::before {
  content: "";
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
    to right,
    transparent 0%,
    #8f97a7 50%,
    transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@keyframes load {
  from {
    left: -150px;
  }
  to {
    left: 100%;
  }
}

@media (min-width: 1264px) and (max-width: 1400px) {
  .platforms {
    grid-template-columns: repeat(7, auto);
  }
  .btn-rrss {
    top: 20px;
  }
  h3 {
    margin-top: 50px;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .platforms {
    grid-template-columns: repeat(6, auto);
  }
  h2 {
    font-size: 26px;
  }
  h2 > span {
    font-size: 26px;
  }
  .btn-rrss {
    top: 25px;
  }
  h3 {
    margin-top: 60px;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .platforms {
    grid-template-columns: repeat(4, auto);
  }
  h2 {
    font-size: 26px;
  }
  h2 > span {
    font-size: 26px;
  }
  .btn-rrss {
    top: 25px;
  }
  h3 {
    margin-top: 60px;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .platforms {
    grid-template-columns: repeat(4, auto);
  }

  h2 {
    font-size: 26px;
  }
  h2 > span {
    font-size: 26px;
  }
  .btn-rrss {
    top: 25px;
  }
  h3 {
    margin-top: 60px;
  }
}

@media (max-width: 600px) {
  .platforms {
    grid-template-columns: repeat(3, auto);
  }
  .div {
    margin: 10px 20px;
  }
  h2 {
    font-size: 24px;
  }
  h2 > span {
    font-size: 24px;
  }
  .btn-rrss {
    top: 45px;
  }
  h3 {
    margin-top: 60px;
    font-size: 18px;
  }
  .description {
    font-size: 14px;
    margin-top: 10%;
  }
}
</style>
